<template>
	<div class="text-justify">
		<app-overlay-loader v-if="preloader" />
		<div class="row">
			<!-- Form Language -->
			<div class="col-lg-12">
				<form
					ref="languageForm"
					:data-url="'/transaction/lead/' + value.id"
					class="mb-0"
					:class="{ 'loading-opacity': preloader }"
				>
					<div class="row">
						<div class="col-lg-12">
							<div class="row">
								<!-- Mother Language -->
								<div class="col-md-6">
									<div class="form-group">
										<label for="input_mother_lang">
											Mother Language
										</label>
										<app-input
											id="input_mother_lang"
											type="multi-select"
											:list="motherLanguageLists"
											:isAnimatedDropdown="true"
											name="mother_lang"
											v-model="languageForm.mother_lang"
										/>
									</div>
								</div>
								<!-- Daily Language -->
								<div class="col-md-6">
									<div class="form-group">
										<label for="input_daily_lang">
											Daily Language
										</label>
										<app-input
											id="input_daily_lang"
											type="multi-select"
											:list="dailyLangLists"
											:isAnimatedDropdown="true"
											name="daily_lang"
											v-model="languageForm.daily_lang"
										/>
									</div>
								</div>
							</div>
							<div class="row">
								<!-- Family Member who Speak Chinese at Home -->
								<div class="col-md-6">
									<div class="form-group">
										<label for="input_family_speaks_chinese"
											>Family Member who Speak Chinese at
											Home</label
										>
										<app-input
											id="input_family_speaks_chinese"
											type="multi-select"
											:list="familySpeaksChineseLists"
											:isAnimatedDropdown="true"
											name="family_speaks_chinese"
											v-model="
												languageForm.family_speaks_chinese
											"
										/>
									</div>
								</div>
								<!-- Reasons to Learn Chinese -->
								<div class="col-md-4">
									<div class="form-group">
										<label
											for="input_reason_to_learn_chinese"
											>Reasons to Learn Chinese</label
										>
										<app-input
											id="input_reason_to_learn_chinese"
											type="multi-select"
											:list="reasonToLearnChineseLists"
											:isAnimatedDropdown="true"
											name="reason_to_learn_chinese"
											v-model="
												languageForm.reason_to_learn_chinese
											"
										/>
									</div>
								</div>
							</div>
							<div class="row">
								<!-- Have Chinese Basic -->
								<div class="col-md-2">
									<div class="form-group">
										<label for="input_chinese_basic"
											>Have Chinese Basic</label
										>
										<app-input
											id="input_chinese_basic"
											type="radio"
											:list="yes_and_no_list"
											v-model="languageForm.chinese_basic"
										/>
									</div>
								</div>
								<!-- Place of Study -->
								<div
									class="col-md-2"
									v-if="languageForm.chinese_basic == 1"
								>
									<div class="form-group">
										<label for="input_chinese_basic_place"
											>Place of Study</label
										>
										<input
											id="input_chinese_basic_place"
											type="text"
											v-model="
												languageForm.chinese_basic_place
											"
											placeholder="Place of Study"
											name="chinese_basic_place"
											class="form-control"
											required
										/>
									</div>
								</div>
								<!-- Length of Study -->
								<div
									class="col-md-2"
									v-if="languageForm.chinese_basic == 1"
								>
									<div class="form-group">
										<label
											for="input_chinese_basic_duration"
											>Length of Study (years)</label
										>
										<input
											id="input_chinese_basic_duration"
											type="number"
											v-model="
												languageForm.chinese_basic_duration
											"
											placeholder="Length of Study"
											name="chinese_basic_duration"
											class="form-control"
											required
										/>
									</div>
								</div>
							</div>
						</div>
					</div>

					<!-- Submit and Clear button -->
					<div class="mt-5 action-buttons">
						<button
							type="submit"
							class="btn btn-primary mr-2"
							:disabled="submitLanguageFormDisabled"
							@click.prevent="submitLanguageForm"
						>
							{{ $t("submit") }}
						</button>
						<!-- <button
							type="submit"
							class="btn btn-secondary"
							@click.prevent="clearLanguageForm"
						>
							{{ $t("clear") }}
						</button> -->
					</div>
				</form>
			</div>
			<!-- Form Consent -->
			<div class="col-lg-12 mt-8">
				<div class="mb-4">
					<h4>CONSENT</h4>
					<hr
						style="border-top: 2px solid black; font-weight: bold"
					/>
				</div>
				<form
					ref="consentForm"
					:data-url="'/transaction/lead/' + value.id"
					class="mb-0"
					:class="{ 'loading-opacity': preloader }"
				>
					<div class="row">
						<div class="col-lg-12">
							<div class="row">
								<!-- Consent 1 -->
								<div class="col-md-12">
									<div class="form-group row">
										<label
											for="radio_consent_1"
											class="col-lg-5"
										>
											Parent and child will follow CLC
											policy, procedures and rules
										</label>
										<div class="col-lg-7">
											<app-input
												id="radio_consent_1"
												type="radio"
												:list="yes_and_no_list"
												v-model="
													consentForm.is_parents_agree_0
												"
											/>
										</div>
									</div>
								</div>
								<!-- Consent 2 -->
								<div class="col-md-12">
									<div class="form-group row">
										<label
											for="radio_consent_2"
											class="col-lg-5"
										>
											Parent will allow child to use CLC
											Flashcards to support their learning
										</label>
										<div class="col-lg-7">
											<app-input
												id="radio_consent_2"
												type="radio"
												:list="yes_and_no_list"
												v-model="
													consentForm.is_parents_agree_1
												"
											/>
										</div>
									</div>
								</div>
								<!-- Consent 3 -->
								<div class="col-md-12">
									<div class="form-group row">
										<label
											for="radio_consent_3"
											class="col-lg-5"
										>
											Parent will allow and encourage
											child to use CLC App Learning
											Support every day
										</label>
										<div class="col-lg-7">
											<app-input
												id="radio_consent_3"
												type="radio"
												:list="yes_and_no_list"
												v-model="
													consentForm.is_parents_agree_2
												"
											/>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<!-- Submit and Clear button -->
					<div class="mt-5 action-buttons">
						<button
							type="submit"
							class="btn btn-primary mr-2"
							:disabled="submitConsentFormDisabled"
							@click.prevent="submitConsentForm"
						>
							{{ $t("submit") }}
						</button>
						<!-- <button
							type="submit"
							class="btn btn-secondary"
							@click.prevent="clearConsentForm"
						>
							{{ $t("clear") }}
						</button> -->
					</div>
				</form>
			</div>
		</div>
	</div>
</template>

<script>
import { LanguageFormMixin } from "./LanguageFormMixin";
import { ConsentFormMixin } from "./ConsentFormMixin";
import GlobalHelperMixin from "../../../../../../../Mixins/global/GlobalHelperMixin";

export default {
	mixins: [LanguageFormMixin, ConsentFormMixin, GlobalHelperMixin],
	props: {
		value: {
			type: Object,
			default: () => {
				return {
					code: "",
					name: "",
					is_active: "",
				};
			},
		},
	},
	data() {
		return {
			preloader: false,
			submitLanguageFormDisabled: true,
			originalLanguageForm: {},
			submitConsentFormDisabled: true,
			originalConsentForm: {},
			languageForm: {
				mother_lang: this.value.mother_lang,
				daily_lang: this.value.daily_lang,
				family_speaks_chinese: this.value.family_speaks_chinese,
				reason_to_learn_chinese: this.value.reason_to_learn_chinese,
				chinese_basic: this.value.chinese_basic,
				chinese_basic_place: this.value.chinese_basic_place,
				chinese_basic_duration: this.value.chinese_basic_duration,
			},
			consentForm: {
				is_parents_agree_0: this.value.is_parents_agree_0 ?? 0,
				is_parents_agree_1: this.value.is_parents_agree_1 ?? 0,
				is_parents_agree_2: this.value.is_parents_agree_2 ?? 0,
			},
			motherLanguageLists: [],
			dailyLangLists: [],
			familySpeaksChineseLists: [
				{ id: 1, value: "Father" },
				{ id: 2, value: "Mother" },
				{ id: 3, value: "Grandfather" },
				{ id: 4, value: "Grandmother" },
				{ id: 5, value: "Brother" },
				{ id: 6, value: "Sister" },
				{ id: 7, value: "Uncle" },
				{ id: 8, value: "Auntie" },
				{ id: 9, value: "Cousin" },
				{ id: 10, value: "Others" },
			],
			reasonToLearnChineseLists: [
				{ id: 1, value: "Interest" },
				{ id: 2, value: "School" },
				{ id: 3, value: "Parents" },
				{ id: 4, value: "Language Skills" },
				{ id: 5, value: "Study Abroad" },
				{ id: 6, value: "Others" },
			],
			yes_and_no_list: [
				{ id: 0, value: "No" },
				{ id: 1, value: "Yes" },
			],
		};
	},
	created() {
		const params = new URLSearchParams(window.location.search);
		this.source_id = params.get("source") || "0";

		axios.get("/master/language?per_page=50")
		.then((response) => {
			this.motherLanguageLists = response.data.data.map((item) => ({
			id: item.id,
			value: item.name,
			}));
			this.dailyLangLists = response.data.data.map((item) => ({
			id: item.id,
			value: item.name,
			}));

			if (this.source_id !== "0") {
			const motherLangSource = this.motherLanguageLists.find(
				(item) => item.id === parseInt(this.source_id)
			);
			if (motherLangSource) {
				this.languageForm.mother_lang = [motherLangSource.id];
			}

			const dailyLangSource = this.dailyLangLists.find(
				(item) => item.id === parseInt(this.source_id)
			);
			if (dailyLangSource) {
				this.languageForm.daily_lang = [dailyLangSource.id];
			}
			}
		})
		.catch((error) => {
			console.error("Error fetching data:", error);
		});
		this.originalLanguageForm = JSON.parse(
			JSON.stringify(this.languageForm)
		);
		this.originalConsentForm = JSON.parse(JSON.stringify(this.consentForm));
	},
	methods: {
		// LANGUAGE FORM
		beforeSubmitLanguageForm() {
			this.preloader = true;
		},
		submitLanguageForm() {
			// Handle form submission here
			const fieldsToCheck = [
				{
					condition: this.languageForm.chinese_basic == 1,
					requiredFields: [
						"chinese_basic_place",
						"chinese_basic_duration",
					],
					errorMessage: "Please select {field}",
				},
			];

			let allFieldsValid = true; // Assume all fields are valid initially

			for (const fieldGroup of fieldsToCheck) {
				if (fieldGroup.condition) {
					for (const field of fieldGroup.requiredFields) {
						if (!this.languageForm[field]) {
							this.$toastr.e(
								fieldGroup.errorMessage.replace(
									"{field}",
									field.replace("_", " ")
								)
							);
							allFieldsValid = false; // Set to false if any field is not valid
						}
					}
				}
			}

			if (allFieldsValid) {
				this.originalLanguageForm = JSON.parse(
					JSON.stringify(this.languageForm)
				);
				this.submitLanguageFormDisabled =
					JSON.stringify(this.languageForm) ===
					JSON.stringify(this.originalLanguageForm);

				this.saveLanguageForm(this.languageForm);
			}
		},
		afterSuccessLanguageForm(res) {
			this.$toastr.s(res.data.message);
			// this.clearLanguageForm();
		},
		afterFinalResponseLanguageForm() {
			this.preloader = false;
			this.scrollToTop(false);
		},
		afterErrorLanguageForm(res) {
			if (res === undefined) {
				return;
			} else if (res.data === undefined) {
				return;
			} else if (res.data.message === undefined) {
				return;
			} else {
				this.$toastr.e(res.data.message);
			}
		},
		clearLanguageForm() {
			// Clear form fields here
			this.languageForm = {};
			// this.basicInfo.custom_file = null;
		},

		// CONSENT FORM
		beforeSubmitConsentForm() {
			this.preloader = true;
		},
		submitConsentForm() {
			// Handle form submission here
			this.originalConsentForm = JSON.parse(
				JSON.stringify(this.consentForm)
			);
			this.submitConsentFormDisabled =
				JSON.stringify(this.consentForm) ===
				JSON.stringify(this.originalConsentForm);
			this.saveConsentForm(this.consentForm);
		},
		afterSuccessConsentForm(res) {
			this.$toastr.s(res.data.message);
			// this.clearConsentForm();
		},
		afterFinalResponseConsentForm() {
			this.preloader = false;
			this.scrollToTop(false);
		},
		afterErrorConsentForm(res) {
			if (res === undefined) {
				return;
			} else if (res.data === undefined) {
				return;
			} else if (res.data.message === undefined) {
				return;
			} else {
				this.$toastr.e(res.data.message);
			}
		},
		clearConsentForm() {
			// Clear form fields here
			this.consentForm = {};
			// this.basicInfo.custom_file = null;
		},
	},
	watch: {
		languageForm: {
			handler: function (val) {
				// parse to int
				val.chinese_basic = parseInt(val.chinese_basic);

				// Check if languageForm has changed
				const isLanguageFormChanged =
					JSON.stringify(val) !==
					JSON.stringify(this.originalLanguageForm);

				// Update the submitLanguageFormDisabled based on the change status
				this.submitLanguageFormDisabled = !isLanguageFormChanged;
			},
			deep: true,
		},
		consentForm: {
			handler: function (val) {
				// Ensure that is_parents_agree values are integers
				val.is_parents_agree_0 = parseInt(val.is_parents_agree_0);
				val.is_parents_agree_1 = parseInt(val.is_parents_agree_1);
				val.is_parents_agree_2 = parseInt(val.is_parents_agree_2);

				// Check if consentForm has changed
				const isConsentFormChanged =
					JSON.stringify(val) !==
					JSON.stringify(this.originalConsentForm);

				// Update the submitConsentFormDisabled based on the change status
				this.submitConsentFormDisabled = !isConsentFormChanged;
			},
			deep: true,
		},
	},
};
</script>

<style scoped>
.ml-40 {
	margin-left: 40px; /* You can adjust the margin value as needed */
}
.mt-8 {
	margin-top: 40px;
}
/* .form-control {
	border: 3px solid;
} */
.required-star {
	color: red;
}
</style>
